import { render, staticRenderFns } from "./Layout_RC.vue?vue&type=template&id=5fd3c71c"
import script from "./Layout_RC.vue?vue&type=script&lang=js"
export * from "./Layout_RC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports